module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYQAAAC8AQMAAABCLUvkAAAABlBMVEUAAADU1NRLDTL1AAAAAnRSTlMALqpFwPcAAABESURBVGje7dkxEQAwCMBAHNS/yzqAkZmNOz77K0jksE8Qp0QMegRBEARBEARBEARBEARBEARBEARBEATRYvENJ4gFogCvE4YJYjK3pQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/square8.png
// module id = 445
// module chunks = 0